import { Button, SxProps } from '@mui/material'

import { cancelBtnStyle } from 'common/styles'
import { useIsPhone } from 'utils/hook'

interface ModalButtonsProps {
  actionHandler: () => void
  onClose: () => void
  textAction: string
  textCancel: string
  actionStyle?: SxProps
}

export default function ModalActionCancelButtons({
  actionHandler,
  onClose,
  textAction,
  textCancel,
  actionStyle,
}: ModalButtonsProps): JSX.Element {
  const isPhone = useIsPhone()

  return (
    <>
      <Button onClick={onClose} sx={cancelBtnStyle}>
        {textCancel}
      </Button>
      <Button onClick={actionHandler} fullWidth={isPhone} variant="outlined" sx={actionStyle ?? {}}>
        {textAction}
      </Button>
    </>
  )
}
